import type { PageCode } from '@gov-nx/module/page';
import {
	EPetitionAttachmentProvider,
	useEPeticeDetailContext,
} from '@gov-nx/module/page';
import { DocumentDownloadContainer } from '@gov-nx/ui/web';
import { EPetitionAttachmentItem } from './EPetitionAttachmentItem';

export interface EPetitionAttachmentsProps {
	code: PageCode;
}

export const EPetitionAttachments = ({ code }: EPetitionAttachmentsProps) => {
	const { attachments, petition } = useEPeticeDetailContext();
	return (
		<DocumentDownloadContainer>
			{attachments?.map((attachment) => (
				<EPetitionAttachmentProvider
					code={code}
					key={attachment.id}>
					<EPetitionAttachmentItem
						code={code}
						attachment={attachment}
						petitionId={petition?.id ?? 0}
					/>
				</EPetitionAttachmentProvider>
			))}
		</DocumentDownloadContainer>
	);
};
